export const navigateToClientDetails = (id: any) => {
	const url = `/client-details?id=${id}`;
	window.open(url, "_blank");
};
